module.exports = __webpack_public_path__ + "img/mark-input-icon.9a2bc4ce.svg";